import { ComponentChildren } from 'preact';

interface ModalSlideProps {
    children: ComponentChildren,
    isTransparent?: boolean
}

export const ModalSlide = ({ children, isTransparent }: ModalSlideProps) => {
    return (
        <div className={`modal-box ${isTransparent ? 'transparent' : ''}`}>
            {children}
        </div>
    )
}
